import { render, staticRenderFns } from "./CheckboxListMobileField.vue?vue&type=template&id=61772c52&"
import script from "./CheckboxListMobileField.vue?vue&type=script&lang=js&"
export * from "./CheckboxListMobileField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports